import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Sidebar } from '@/app/layout/Sidebar';
import { Topbar } from '@/app/layout/Topbar';
import { UpdateHinweis } from '@/app/layout/UpdateHinweis';
import { BackupNag } from '@/modules/settings/BackupNag';
import { LinkNamesProvider } from '@/modules/links/LinkNamesProvider';
import { TaskDialogHost } from '@/modules/tasks/components/TaskDialog';
import { PriorityColorsApplier } from '@/modules/settings/PriorityColorsApplier';
import { ErinnerungsHost } from '@/modules/calendar/components/ErinnerungsHost';
import { RueckgaengigHost } from '@/modules/papierkorb/RueckgaengigHost';
import { SuchDialogHost } from '@/modules/suche/SuchDialog';
import { SerienFrageHost } from '@/modules/tasks/SerienFrageHost';
import { KeyResultAbgleich } from '@/modules/goals/KeyResultAbgleich';
import { KalenderPflege } from '@/modules/training/kalender/KalenderPflege';
import { DeepLinks } from '@/modules/benachrichtigungen/DeepLinks';
import { de } from '@/i18n/de';

export function AppShell() {
  return (
    <LinkNamesProvider>
      <div className="flex h-full">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          {/* Neue App-Version (F-47) - ausserhalb der scrollenden Flaeche, immer sichtbar. */}
          <UpdateHinweis />
          <BackupNag />
          <main className="min-h-0 flex-1 overflow-y-auto">
            {/*
              Alle Seiten ausser der Startseite werden erst beim Aufruf geladen
              (siehe app/routes.tsx). Diese Huelle faengt die Zeit dazwischen ab.
              Sie ist absichtlich karg: bei einem lokalen Nachladen ist sie nur
              wenige Millisekunden sichtbar, und ein auffaelliger Ladebalken
              wuerde dabei mehr floekern als helfen.
            */}
            <Suspense
              fallback={
                <p className="px-6 py-10 text-center text-sm text-ink-faint">
                  {de.common.loading}
                </p>
              }
            >
              <Outlet />
            </Suspense>
          </main>
        </div>

        {/* Ein Dialog fuer die ganze App - jede Aufgabenzeile oeffnet ihn. */}
        <TaskDialogHost />
        {/* Globale Suche (F-18): Strg+K, Such-Knopf, Schlagwort. */}
        <SuchDialogHost />
        {/* Rueckfrage bei wiederkehrenden Aufgaben (F-24). */}
        <SerienFrageHost />
        {/* Automatische Key Results nachziehen (V-06, F-22). */}
        <KeyResultAbgleich />
        <KalenderPflege />
        {/* Selbst gewaehlte Prioritaetsfarben ueberschreiben die Tokens (V-04). */}
        <PriorityColorsApplier />
        {/* Links aus Benachrichtigungen fuehren direkt zum Eintrag (F-30/F-31). */}
        <DeepLinks />
        {/*
          Gemeinsamer Platz unten rechts fuer schwebende Meldungen: Termin-
          Erinnerungen (F-04 f) und die Rueckgaengig-Meldung (F-45) stapeln
          sich, statt sich am Handy (360 px) zu ueberdecken. Der Platz selbst
          faengt keine Klicks ab, nur die Karten darin.
        */}
        <div className="pointer-events-none fixed inset-x-4 bottom-4 z-50 flex flex-col items-end gap-2 sm:left-auto sm:w-[22rem]">
          <ErinnerungsHost />
          <RueckgaengigHost />
        </div>
      </div>
    </LinkNamesProvider>
  );
}
